import cx from 'classnames';

import s from './TexturedCircle.module.css';

export interface TexturedCircleProps {
  className?: string;
}

const TexturedCircle = ({ className }: TexturedCircleProps) => {
  return (
    <div className={cx(s.circleWrapper, className)}>
      <div className={cx(s.circle)} />
    </div>
  );
};

export { TexturedCircle };
